import {NavLink, Route, RouteComponentProps, Switch, withRouter} from "react-router-dom";
import React from "react";
import {connect, useSelector} from "react-redux";
import {login, showLogin} from "../../user/UserActions";
import {Dispatch} from "redux";
import {AppState} from "../../RootReducer";
import {
    showSideMenu,
    toggleShowPoker,
    toggleShowSportsbook,
    toggleShowUserNavigation
} from "../../navigation/NavigationActions";
import {AccountBalance, AppMode, ManualLoginRequest, MenuItem, MenuPosition, Settings} from "../../http/protocol";
import {ContentModelName, GlobalPayload, PopupAppInstall} from "../../contenful/types";
import {fetchContent} from "../../contenful/ContentfulActions";
import "./styles/NavMenu.scss";
import {fetchSettings} from "../../settings/SettingsActions";
import {t} from "../../i18n";
import {getContainer} from "../../ioc/IOCSetup";
import {mapMenuItemData, MenuItemData} from "./MenuUtils";
import {HamburgerIcon} from "./DesktopTopMenu";
import MobileLoggedIn from "../../layout/MobileLoggedin";
import { PATH } from "../../onboardingpage/modalview/UserModalController";
import { setModalPath } from "../../onboardingpage/modalview/utils";
import { getIsGlifeContext } from "../../selectors/settings-selectors";
import { getAppMode } from "../../selectors/user-selectors";

interface State {
    mobile: boolean;
    animate: boolean;
    scrolled: boolean;
    smallScreen: boolean;
    displaySideMenu? : boolean;
}

interface Props extends RouteComponentProps {
    showLogin? : ()=> void;
    loggedIn?: boolean;
    balances?: AccountBalance[];
    transparent?: boolean;
    showUserNavigation? : (show : boolean) => void;
    fetchContent: typeof fetchContent;
    fetchSettings: typeof fetchSettings;
    login: typeof login;
    global?: GlobalPayload;
    settings?: Settings;
    animate?: boolean;
    delay?: number;
    lng: string;
    popupAppInstall?: PopupAppInstall;
    appMode?: AppMode;
    sportsbookVisible:boolean;
    toggleShowSportsbook? : typeof toggleShowSportsbook;
    toggleShowPoker? : typeof toggleShowPoker;
    showSideMenu : (show : boolean) => void;
    userModal: {verification: boolean, newUser: boolean},
    isLandingPage? : boolean;
    pokerLoadingComplete? : boolean;
    position?: MenuPosition;
}


export class NavMenuMobile extends React.Component<Props, State> {

    constructor(props : Props) {
        super(props);

        this.state = {
            mobile: false,
            // animate: this.props.animate == undefined ? false : this.props.animate
            animate: false,
            scrolled: false,
            smallScreen: false,
            displaySideMenu : false
        }
    }
    mounted = false;
    isScrolled = () => {
        let nav = document.getElementById("mainNav");
        if(nav) {
            if(window.pageYOffset > 70) {
                this.setState({ scrolled: true })
            } else {
                this.setState({ scrolled: false })
            }

        };

    }

    componentDidMount(): void {
        this.mounted = true;

        if(!this.props.transparent) {
            window.addEventListener("scroll", this.isScrolled);
        }

        if(this.props.global == undefined) {
            this.props.fetchContent(ContentModelName.GLOBAL, this.props.lng);
        }

        if(this.props.settings == undefined) {
            this.props.fetchSettings();
        }

        // Should probably have another system here
        window.addEventListener("resize", this.resize);
        this.resize("start");

        if(this.props.animate != undefined) {
            setTimeout(() => {
                this.setState({animate: true});
            }, this.props.delay)

        }
    }
    componentDidUpdate(prevProps: Props): void {
        if(this.props.lng) {
            if(this.props.lng !== prevProps.lng) {
                this.props.fetchContent(ContentModelName.GLOBAL, this.props.lng);
            }
        }
    }

    componentWillUnmount(): void {

        this.mounted = false;
        if(!this.props.transparent) {
            window.removeEventListener("scroll", this.isScrolled);
        }

        window.removeEventListener("resize", this.resize);
    }

    resize = (value: any): any => {
        if(window.innerWidth <= 1200 && window.innerWidth > 768) {
            this.setState({smallScreen: true, mobile: false})
        } else if(window.innerWidth <= 768) {
            this.setState({mobile: true})
        } else {
            this.setState({mobile: false, smallScreen: false})
        }
    };
    toKey(m : MenuItem) {
        let key = ""+m.type;
        if(m.name) {
            key +=m.name;
        }
        return key;
    }

    showSportsbook (show:boolean) {
        if(this.props.toggleShowSportsbook) {
            this.props.toggleShowSportsbook(show);
        }

    }


    renderMenuItems()  : any {
        if(this.props.lng == undefined) {
            this.props.fetchContent(ContentModelName.GLOBAL, getContainer().getSettingsService().getActiveLocale().code);
        }
        let menu = getContainer().getSettingsService().getMenu();
        if(!menu || !menu.items) {
            return false;
        }
        let items = menu.items.filter(m => m.includeInDesktopMenu).map((m :MenuItem ) => mapMenuItemData(m, this.props.lng, this.props.history.location.pathname));

        return items.map((m : MenuItemData)=> {
                return (
                    <NavLink key={m.name}
                             exact={true}
                             activeClassName={"active"}
                             to={m.url}
                             href={m.text}
                             className={"nav-link"}
                             isActive={(match, location) => m.active}>
                        {m.text}
                    </NavLink>
                )
            });
    }

    render() {
        return (
            <Switch>
                <Route exact path="/casino/play/:gameId/:provider"></Route>
                <Route exact path="/casino/play/:gameId/:provider/:mode"></Route>
                <Route exact path="/app"></Route>
                <Route exact path={"/blocked/:country"}></Route>
                <Route exact path="/casino/search"></Route>
                {this.props.pokerLoadingComplete && <Route exact path="/poker/play"></Route>}
                <Route path="/">
                    <header id="mainNav" className={"main-menu-container header mobile " + (this.state.scrolled ? "scrolled" : "")  + (this.props.loggedIn ? " logged-in" : "") + (this.props.isLandingPage ? " landing-page" : "")}>
                        <div className="headerWrapper">
                            { !this.props.loggedIn && (
                                <div className={"header-container"}>
                                    <div className={"headerLeft"}>
                                        {this.props.position !== MenuPosition.FIXED && <HamburgerIcon onClick={()=> this.props.showSideMenu && this.props.showSideMenu(true)}/>}
                                    </div>
                                    <div className={"headerMiddle"}>
                                        <NavLink onClick={() => this.showSportsbook(false)} className={"linkCss"} exact={true} to="/">
                                            {this.props.global && <BrandLogo global={this.props.global} />}
                                        </NavLink>
                                    </div>
                                    <div className={"headerRight"}>
                                        <div className="lngAndButtonWrap">
                                            <button className={"btn btn-secondary small login-button fixed-menu-btn"} onClick={() => {setModalPath({path: {type: PATH.LOGIN, modal: PATH.MODAL_TYPE}, history: this.props.history, options: this.props.userModal})}}>{t("account.login")}</button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {this.props.loggedIn && (
                                <div className={"header-container"}>
                                    <div className={"head headerLeft"}>
                                        <NavLink onClick={() => this.showSportsbook(false)} className={"linkCss"} exact={true} to="/">
                                            {this.props.global && <BrandLogo global={this.props.global} />}
                                        </NavLink>
                                    </div>
                                    <div className={"head headerMiddle"}></div>
                                    <div className="head headerRight">
                                        <MobileLoggedIn/>
                                    </div>
                                </div>
                            )}
                        </div>
                    </header>
                </Route>
            </Switch>
        );
    }
}
export const BrandLogo = (props : { global : GlobalPayload})  => {
    const isEmbeddedAppMode = useSelector(getAppMode) === AppMode.EMBEDDED;
    const isGlifeContext = useSelector(getIsGlifeContext);

    let logo = getContainer().getSettingsService().getAppModeLogo();
    if(isGlifeContext && isEmbeddedAppMode && logo) {
        return (
            <img alt="logo" className={"logo light-logo"} src={logo} />
        )
    }

    return (
    <>
        {props.global.logoDark && props.global.logoDark.fields && props.global.logoDark.fields.file && props.global.logoDark.fields.file.url &&
            <img alt="logo" className={"logo dark-logo"} src={props.global.logoDark.fields.file.url}/>
        }
        {props.global.logo && props.global.logo.fields && props.global.logo.fields.file && props.global.logo.fields.file.url &&
            <img alt="logo" className={"logo light-logo"} src={props.global.logo.fields.file.url}/>
        }
    </>
)}

const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
        showLogin : ()=> dispatch(showLogin(true)),
        showUserNavigation : (show : boolean) => dispatch(toggleShowUserNavigation(show)),
        fetchSettings: () => dispatch(fetchSettings() as any),
        login: (req:ManualLoginRequest) => dispatch(login(req)as any),
        toggleShowSportsbook: (show:boolean) => dispatch(toggleShowSportsbook(show)),
        toggleShowPoker: (show:boolean) => dispatch(toggleShowPoker(show)),
        showSideMenu : (show : boolean) => dispatch(showSideMenu(show))
    }
);
let mapStateToProps = (app : AppState)=> {
    return {
        settings: app.settings.settings,
        userModal: app.user.modal,
        loggedIn : app.user.user?.loggedIn,
        balances : app.user.balances,
        global: app.contentful.global,
        lng: getContainer().getSettingsService().getActiveLocale().code,
        popupAppInstall: app.contentful.popupAppInstall,
        appMode : app.user.appMode,
        sportsbookVisible : app.navigation.sportsbookVisible,
        isLandingPage : app.navigation.isLandingPage,
        pokerLoadingComplete : app.navigation.pokerLoadingComplete
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter<Props,any>(NavMenuMobile));
